import PlacesAutocomplete from './PlacesAutocomplete';

export type { AutocompletePlace } from './PlacesAutocomplete';

export default PlacesAutocomplete;
